// extracted by mini-css-extract-plugin
export default {"dropStyle":"style_dropStyle__Qv-NZ","lab":"style_lab__udFZQ","container":"style_container__1TiFR","errorText":"style_errorText__AqePw","box":"style_box__HYOiV"};